import React, { useState } from "react";
import TooltipArrow from "../images/TooltipArrow";

const CustomTooltip_AML = ({ children, data }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <div
        className=" flex"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>

      <div className="flex ">
        <div
          className={` ${
            visible ? "visible" : "invisible"
          } absolute min-w-[200px] h-fit bg-[#262626] rounded-2xl bottom-6 right-3 flex `}
        >
          <div className=" relative p-4 text-white">{data}</div>
          <div className=" absolute -bottom-1 rotate-180 left-[180px]">
            <TooltipArrow />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomTooltip_AML;
